/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const ParkingIcon = (props) => (
  <SvgIcon
    {...props}
    width="225.000000pt"
    height="225.000000pt"
    viewBox="-20 -15 140 140"
    enableBackground="new 0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="g9164" transform="matrix(1.0953 0 0 1.0953 989.71 -519.18)">
      <path
        id="front-wheel"
        d="m-829.8 558c0 4.1-3.3 7.3-7.3 7.3-4.1 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3 7.3 3.3 7.3 7.3"
      />
      <path
        id="bus-chassis"
        d="m-815.6 521.2h-84.9c-1 0-1.8 0.8-1.8 1.8v34.1c0 1 0.8 1.8 1.8 1.8h11v-0.8c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v0.8h21.1v-1c0-5.8 4.7-10.5 10.5-10.5s10.5 4.7 10.5 10.5v1h11.1c1 0 1.8-0.8 1.8-1.8v-34.1c-0.3-1-1.1-1.8-2.1-1.8zm-65.1 22.2h-17.7v-14.7h17.7v14.7zm21 0h-17.7v-14.7h17.7v14.7zm21 0h-17.7v-14.7h17.7v14.7zm20.9 0h-17.7v-14.7h17.7v14.7z"
      />
      <path
        id="rear-wheel"
        d="m-871.7 558.2c0 4.1-3.3 7.3-7.3 7.3-4.1 0-7.3-3.3-7.3-7.3s3.3-7.3 7.3-7.3c4-0.1 7.3 3.2 7.3 7.3"
      />
    </g>
    <g id="text" transform="translate(.42373 -2.7288)">
      <path
        id="park-p"
        d="m9.5113 3.4319h18.601q8.2961 0 12.721 3.6968 4.4537 3.6677 4.4537 10.479 0 6.8406-4.4537 10.537-4.4246 3.6677-12.721 3.6677h-7.3937v15.078h-11.207v-43.46zm11.207 8.1214v12.138h6.2002q3.2602 0 5.0359-1.5719 1.7756-1.601 1.7756-4.5119t-1.7756-4.4828-5.0359-1.5719h-6.2002z"
      />
      <path
        id="plus"
        d="m76.142 9.5157v15.253h15.195v6.8697h-15.195v15.253h-6.9279v-15.253h-15.195v-6.8697h15.195v-15.253h6.9279z"
      />
    </g>
  </SvgIcon>
);
export default ParkingIcon;
